(() => {
  const hoverOpenedDetails = new WeakSet();
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || !canHover.matches) return;
    const detail = event.target.closest('.labelInformation details');
    if (!detail || detail.contains(event.relatedTarget) || detail.open) return;
    hoverOpenedDetails.add(detail);
    detail.open = true;
  });
  document.addEventListener('pointerout', event => {
    const detail = event.target.closest('.labelInformation details');
    if (!detail || detail.contains(event.relatedTarget) || !hoverOpenedDetails.has(detail)) return;
    hoverOpenedDetails.delete(detail);
    if (!detail.contains(document.activeElement)) detail.open = false;
  });
  document.addEventListener('click', event => {
    const summary = event.target.closest('.labelInformation details > summary');
    if (!summary || !hoverOpenedDetails.has(summary.parentElement)) return;
    // Clicking a previewed row keeps it open after the pointer leaves.
    event.preventDefault();
    hoverOpenedDetails.delete(summary.parentElement);
  });
  const showMedia = (gallery, id) => {
    if (!gallery || !id || !gallery.querySelector(`[data-media-panel="${id}"]`)) return;
    gallery.querySelectorAll('[data-media-panel]').forEach(panel => {
      const active = panel.dataset.mediaPanel === id;
      panel.hidden = !active;
      if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    gallery.querySelectorAll('[data-media-target]').forEach(button => {
      const active = button.dataset.mediaTarget === id;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };
  const closeMenus = () => document.querySelectorAll('[data-menu-toggle]').forEach(toggle => {
    toggle.setAttribute('aria-expanded', 'false');
    document.getElementById(toggle.getAttribute('aria-controls'))?.classList.remove('open');
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      document.getElementById(toggle.getAttribute('aria-controls'))?.classList.toggle('open', open);
    } else if (event.target.closest('.nav a') || !event.target.closest('.header')) closeMenus();
    const thumbnail = event.target.closest('[data-media-target]');
    if (thumbnail) showMedia(thumbnail.closest('[data-gallery]'), thumbnail.dataset.mediaTarget);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenus();
    const thumbnail = event.target.closest('[data-media-target]');
    if (!thumbnail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const buttons = [...thumbnail.parentElement.querySelectorAll('button')];
    const next = buttons[(buttons.indexOf(thumbnail) + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length];
    next.focus();
  });
  ['pointerover', 'focusin'].forEach(type => document.addEventListener(type, event => {
    const thumbnail = event.target.closest('[data-media-target]');
    if (thumbnail && (type !== 'pointerover' || event.pointerType === 'mouse')) showMedia(thumbnail.closest('[data-gallery]'), thumbnail.dataset.mediaTarget);
  }));
  const updateVariant = (select, updateUrl = false) => {
    const section = select.closest('[data-product-section]');
    const option = select.selectedOptions[0];
    if (!section || !option) return;
    const available = option.dataset.available === 'true';
    const price = section.querySelector('[data-product-price]');
    price.replaceChildren();
    if (option.dataset.compare) {
      const original = document.createElement('span'); original.className = 'originalPrice';
      if (price.dataset.originalLabel) original.append(document.createTextNode(price.dataset.originalLabel + ' '));
      const compare = document.createElement('s'); compare.textContent = option.dataset.compare; original.append(compare); price.append(original);
    }
    const sale = document.createElement('span'); sale.className = 'salePrice';
    sale.textContent = (price.dataset.saleLabel ? price.dataset.saleLabel + ' ' : '') + option.dataset.price; price.append(sale);
    const button = section.querySelector('[data-add-button]');
    button.disabled = !available;
    button.textContent = available ? (window.location.pathname.startsWith('/ko') ? '장바구니에 담기' : 'Add to cart') : (window.location.pathname.startsWith('/ko') ? '품절' : 'SOLD OUT');
    const payment = section.querySelector('[data-payment-button]');
    payment.hidden = !available || payment.dataset.enabled !== 'true';
    const rules = JSON.parse(section.querySelector('[data-variant-rules]').textContent)[option.value];
    const quantity = section.querySelector('[data-product-quantity]');
    quantity.min = rules?.min || 1;
    quantity.step = rules?.increment || 1;
    if (rules?.max) quantity.max = rules.max; else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    const quantityControls = section.querySelector('[data-quantity-controls]');
    quantityControls.hidden = quantityControls.dataset.showQuantity !== 'true' && Number(quantity.min) <= 1 && Number(quantity.step) <= 1;
    showMedia(section.querySelector('[data-gallery]'), option.dataset.media);
    if (updateUrl && !window.Shopify?.designMode) {
      const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
    }
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) updateVariant(event.target, true);
  });
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    entry.target.dataset.playing = String(entry.isIntersecting && !reducedMotion.matches);
  }), { threshold: 0.15 }) : null;
  const initialize = root => {
    root.querySelectorAll('[data-variant-select]').forEach(select => updateVariant(select));
    root.querySelectorAll('.storyLightCycle').forEach(element => observer?.observe(element));
  };
  const updateHeader = () => document.querySelectorAll('.header.overlay').forEach(header => header.classList.toggle('scrolled', window.scrollY > 16));
  initialize(document); updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  reducedMotion.addEventListener('change', () => {
    document.querySelectorAll('.storyLightCycle').forEach(element => { element.dataset.playing = 'false'; observer?.unobserve(element); observer?.observe(element); });
  });
  document.addEventListener('shopify:section:load', event => { initialize(event.target); updateHeader(); });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.storyLightCycle').forEach(element => observer?.unobserve(element)));
})();
